import React from "react";
import { Link } from "react-router-dom";
import { MenuItem } from "@material-ui/core";

const Internal = ({ onItemClick = () => { }, link, title }) => {
  return (
    <MenuItem component={Link} to={link} onClick={onItemClick}>
      {title}
    </MenuItem>
  );
};

const External = ({ onItemClick = () => { }, link, title }) => {
  return (
    <MenuItem onClick={onItemClick}>
      <a
        style={{
          textDecoration: "none",
          color: "inherit",
          textTransform: "capitalize",
        }}
        rel="noopener noreferrer"
        target="_blank"
        href={link}
        dangerouslySetInnerHTML={{ __html: title }}
      ></a>
    </MenuItem>
  );
};

const Item = ({ type, ...others }) => {
  if (type === "Internal") {
    return <Internal {...others} />;
  }
  return <External {...others} />;
};

export default Item;
